import { Route, Routes } from 'react-router-dom'

import OverlayScrollbar from 'common/components/OverlayScrollBar'

import {
  ISavedState,
  IStateAssessment
} from 'features/RiskManagement/Assessments'
import MapWrapper from 'features/RiskManagement/Assessments/Components/MapWrapper'
import WISAssessmentIncompletePlaceholder from 'features/RiskManagement/Components/WISAssessmentIncompletePlaceholder'

import { LineGraphsInit, LineTableInit } from './LineGraphsTableInit'
import { SystemGraphsInit, SystemTableInit } from './SystemGraphsTableInit'

type ViewType = 'line' | 'system'

interface SavedStatePageContentProps {
  viewType: ViewType
  qraBasePath: string
  qraViewBasePath: string
  stateId: string
  assessmentId?: string
  currentState?: ISavedState
  currentAssessment?: IStateAssessment
  isLoading: boolean
  isCompletedAssessment?: boolean
  lineId?: string
}

interface GraphViewProps {
  viewType: string
  qraBasePath: string
  qraViewBasePath: string
  stateId: string
  assessmentId?: string
  currentState?: ISavedState
  currentAssessment?: IStateAssessment
  lineId?: string
}

interface TableViewProps {
  viewType: string
  qraBasePath: string
  qraViewBasePath: string
  stateId: string
  assessmentId?: string
}

const GraphsViewWrapper = ({
  viewType,
  qraBasePath,
  qraViewBasePath,
  stateId,
  assessmentId,
  currentState,
  currentAssessment,
  lineId
}: GraphViewProps) => (
  <div className='flex flex-1'>
    <OverlayScrollbar>
      {viewType === 'line' ? (
        <LineGraphsInit
          qraBasePath={qraBasePath}
          qraViewBasePath={qraViewBasePath}
          stateId={stateId}
          assessmentId={assessmentId}
        />
      ) : (
        <SystemGraphsInit
          qraBasePath={qraBasePath}
          qraViewBasePath={qraViewBasePath}
          stateId={stateId}
          assessmentId={assessmentId}
        />
      )}
    </OverlayScrollbar>
    <div className='w-1/3'>
      {currentState?.baselineId != null && (
        <MapWrapper
          baselineId={currentState.baselineId}
          assessmentId={assessmentId}
          continuousRouteId={lineId}
          layer1Name={currentState?.name}
          layer2Name={currentAssessment?.name}
        />
      )}
    </div>
  </div>
)

const TableViewWrapper = ({
  viewType,
  qraBasePath,
  qraViewBasePath,
  stateId,
  assessmentId
}: TableViewProps) =>
  viewType === 'line' ? (
    <LineTableInit
      qraBasePath={qraBasePath}
      qraViewBasePath={qraViewBasePath}
      stateId={stateId}
      assessmentId={assessmentId}
    />
  ) : (
    <SystemTableInit
      qraBasePath={qraBasePath}
      qraViewBasePath={qraViewBasePath}
      stateId={stateId}
      assessmentId={assessmentId}
    />
  )

export const SavedStatePageContent = (props: SavedStatePageContentProps) => {
  const { isLoading, assessmentId, isCompletedAssessment, currentAssessment } =
    props

  // Show placeholder when loading or assessment is not completed (if not baseline)
  if (isLoading || (assessmentId != null && !isCompletedAssessment)) {
    return (
      <WISAssessmentIncompletePlaceholder
        assessment={currentAssessment}
        isLoading={isLoading}
      />
    )
  }

  return (
    <div className='flex flex-1 overflow-auto bg-gray-100'>
      <Routes>
        <Route path='graphs' element={<GraphsViewWrapper {...props} />} />
        <Route path='data-table' element={<TableViewWrapper {...props} />} />
        <Route index element={<GraphsViewWrapper {...props} />} />
        <Route path='*' element={<GraphsViewWrapper {...props} />} />
      </Routes>
    </div>
  )
}
